<template>
    <div class="home">
        <!-- banner -->
        <div class="bannner">
            <el-carousel :interval="5000" arrow="always" height="300px" autoplay>
                <el-carousel-item v-for="item in bannerList" :key="item.id">
                    <img :src="item.imageUrl" />
                </el-carousel-item>
            </el-carousel>
        </div>

        <!-- 公告 -->
        <div class="container notice">
            <div class="noticeIcon"></div>
            <div class="mainBody">
                <marquee>山东捷采全新网站上线，我们的产品俱全，应有尽有，欢迎搜索</marquee>
            </div>
            <div class="date">2020.06.01</div>
        </div>

        <div class="container brand">
            <div class="items">
                <div
                    class="item"
                    v-for="(item, index) in brandList"
                    :key="index"
                    v-show="item.images"
                >
                    <img :src="item.images" />
                </div>
            </div>
        </div>
        <!-- <div class="container product">
            <div
                class="firstItem"
                style="background:url('https://image-c.ehsy.com/uploadfile/opc/editor/uc/201704/01/1491012392394749.jpg');background-size:100% 100%;"
            >
                <div class="name">工具/耗材</div>
                <div class="category_items">
                    <div class="item">电动工具</div>
                    <div class="item">气动工具</div>
                    <div class="item">扳手/手动套筒</div>
                    <div class="item">锤/锉/锯/刀/尺</div>
                    <div class="item">扭力工具</div>
                    <div class="item">充电式工具</div>
                </div>
            </div>
            <div class="secondItem">
                <el-tabs v-model="activeGongju">
                    <el-tab-pane label="打磨及耗材" name="first"></el-tab-pane>
                    <el-tab-pane label="工具套装" name="second"></el-tab-pane>
                    <el-tab-pane label="安全刀具" name="third"></el-tab-pane>
                    <el-tab-pane label="扭力工具" name="fourth"></el-tab-pane>
                    <el-tab-pane label="电工维修" name="five"></el-tab-pane>
                </el-tabs>
                <div class="nav_product_list">
                    <div class="nav_product" v-for="(item, index) in gongjuList" :key="index">
                        <img width="170" height="170" :src="item.images" />
                        <div class="name">{{ item.chName }}</div>
                        <div class="price">¥ {{ item.salesPrice }}</div>
                    </div>
                </div>
            </div>
            <div class="thirdItem">
                <div class="title">工具/耗材品牌</div>
                <img
                    src="https://image-c.ehsy.com/uploadfile/opc/img/2016/12/07/20161207211226988.png"
                    width="120"
                    height="96"
                />
                <div class="name">世达</div>
                <div class="disc">
                    SATA世达中国手工具市场第一品牌，是美国APEX集团在中国的全资子公司，主要经营手工具、汽保设备和个人劳防用品。用于汽车维修、保养，能源建设，轨道交通，机械制造，电子电工等众多行业。SATA世达首创“终身保用”服务，已成为手工具服务标准；
                </div>
                <div class="name2">进入品牌专区<i class="el-icon-caret-right"></i></div>
                <div class="brandList">
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/img/2016/12/09/20161209105149373.png"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/img/2016/12/09/20161209105627398.png"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/brand/makita153.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/img/2016/12/09/20161209105016158.png"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/img/2016/11/23/20161123135831742.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/brand/TOHNICHI295.jpg"
                    />
                </div>
            </div>
            <div class="fourItem">
                <div class="title">工具/耗材排行榜</div>
                <div
                    class="rank_product"
                    v-for="(item, index) in gongjuListrank"
                    :key="index"
                    @click="goPdDetail(item.id)"
                >
                    <div class="left">
                        <div class="name">{{ item.chName }}</div>
                        <div class="price">¥ {{ item.marketPrice }}</div>
                    </div>
                    <div class="right">
                        <img width="60" height="60" :src="item.images" />
                    </div>
                </div>
            </div>
        </div>

        <div class="container product">
            <div
                class="firstItem"
                style="background:url('https://image-c.ehsy.com/uploadfile/opc/editor/uc/201704/01/1491012490969659.jpg');background-size:100% 100%;"
            >
                <div class="name">劳保/安全</div>
                <div class="category_items">
                    <div class="item">安全标识</div>
                    <div class="item">呼吸防护</div>
                    <div class="item">化学品存储/泄漏处理</div>
                    <div class="item">手部防护</div>
                    <div class="item">足部防护</div>
                    <div class="item">安全锁具</div>
                </div>
            </div>
            <div class="secondItem">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="呼吸防护" name="first"></el-tab-pane>
                    <el-tab-pane label="手部防护" name="second"></el-tab-pane>
                    <el-tab-pane label="足部防护" name="third"></el-tab-pane>
                    <el-tab-pane label="道路安全" name="fourth"></el-tab-pane>
                    <el-tab-pane label="安全标识" name="five"></el-tab-pane>
                </el-tabs>
                <div class="nav_product_list">
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                </div>
            </div>
            <div class="thirdItem">
                <div class="title">工具/耗材品牌</div>
                <img
                    src="https://image-c.ehsy.com/uploadfile/opc/editor/uc/202008/31/1598836013543713.png"
                    width="120"
                    height="96"
                />
                <div class="name">世达</div>
                <div class="disc">
                    SATA世达中国手工具市场第一品牌，是美国APEX集团在中国的全资子公司，主要经营手工具、汽保设备和个人劳防用品。用于汽车维修、保养，能源建设，轨道交通，机械制造，电子电工等众多行业。SATA世达首创“终身保用”服务，已成为手工具服务标准；
                </div>
                <div class="name2">进入品牌专区<i class="el-icon-caret-right"></i></div>
                <div class="brandList">
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/editor/uc/201704/05/1491356324534840.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/editor/uc/202104/07/1617785802526227.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/img/2016/12/09/20161209104726565.png"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/img/2016/12/09/20161209105227262.png"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/brand/ansell45.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/brand/SAFEWARE44.jpg"
                    />
                </div>
            </div>
            <div class="fourItem">
                <div class="title">工具/耗材排行榜</div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="container product">
            <div
                class="firstItem"
                style="background:url('https://image-c.ehsy.com/uploadfile/opc/editor/uc/201704/01/1491012696725685.jpg');background-size:100% 100%;"
            >
                <div class="name">清洁/办公</div>
                <div class="category_items">
                    <div class="item">办公用品</div>
                    <div class="item">工业擦拭</div>
                    <div class="item">光源</div>
                    <div class="item">清洁设备</div>
                    <div class="item">办公设备</div>
                    <div class="item">通讯设备</div>
                </div>
            </div>
            <div class="secondItem">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="办公用品" name="first"></el-tab-pane>
                    <el-tab-pane label="清洁设备" name="second"></el-tab-pane>
                    <el-tab-pane label="工业擦拭" name="third"></el-tab-pane>
                    <el-tab-pane label="办公设备及耗材" name="fourth"></el-tab-pane>
                    <el-tab-pane label="3C数码" name="five"></el-tab-pane>
                </el-tabs>
                <div class="nav_product_list">
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                    <div class="nav_product">
                        <img
                            width="170"
                            height="170"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/04/06/20170406093923237_M.jpg"
                        />
                        <div class="name">世达组合扳手，9件套公制球形内六角扳手, 09105</div>
                        <div class="price">¥ 91.90</div>
                    </div>
                </div>
            </div>
            <div class="thirdItem">
                <div class="title">清洁/办公品牌</div>
                <img
                    src="https://image-c.ehsy.com/uploadfile/opc/img/2016/12/09/20161209105411249.png"
                    width="120"
                    height="96"
                />
                <div class="name">金佰利</div>
                <div class="disc">
                    SATA世达中国手工具市场第一品牌，是美国APEX集团在中国的全资子公司，主要经营手工具、汽保设备和个人劳防用品。用于汽车维修、保养，能源建设，轨道交通，机械制造，电子电工等众多行业。SATA世达首创“终身保用”服务，已成为手工具服务标准；
                </div>
                <div class="name2">进入品牌专区<i class="el-icon-caret-right"></i></div>
                <div class="brandList">
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/brand/karcher312.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/editor/uc/202012/16/1608083091309503.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/editor/uc/202012/15/1608010722981281.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/brand/Brother514.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/brand/Motorola270.jpg"
                    />
                    <img
                        height="62"
                        width="78"
                        src="https://image-c.ehsy.com/uploadfile/opc/editor/uc/202012/15/1608010895587397.jpg"
                    />
                </div>
            </div>
            <div class="fourItem">
                <div class="title">清洁/办公排行榜</div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
                <div class="rank_product">
                    <div class="left">
                        <div class="name">永固油漆刷，毛刷，2寸</div>
                        <div class="price">¥ 2.99</div>
                    </div>
                    <div class="right">
                        <img
                            width="60"
                            height="60"
                            src="https://image-c.ehsy.com/uploadfile/opc/img/2017/07/24/20170724132304052_M.jpg"
                        />
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 右侧栏 -->
        <div class="fixed">
            <div class="item" @click="toPage('/shopCart')">
                <img src="../assets/home-01.png" alt />
            </div>
            <div class="item" @click="toQQ">
                <img src="../assets/home-02.png" alt />
            </div>
            <div class="item" @click="toPage('/center/order')">
                <img src="../assets/home-03.png" alt />
            </div>
            <div class="item" @click="toTop" v-if="scrollTop > 600">
                <img src="../assets/home-06.png" alt />
            </div>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/common';

export default {
    name: 'home',
    data() {
        return {
            bannerList: [
                {
                    linkUrl: 'http://wwww.baidu.com',
                    imageUrl: '/banner.png',
                },
            ],
            specialProducts: [],
            promotionProducts: [],
            scrollTop: 0,

            // 工具/耗材
            activeGongju: 'first',
            gongjuList: [],
            gongjuListrank: [],

            activeName: 'first',

            brandList: [],
        };
    },
    methods: {
        getBrandList() {
            apis.getBrandList({}).then(res => (this.brandList = res.data));
        },
        goPdDetail(val) {
            this.$router.push({ path: '/product-detail/' + val });
        },
        toPage(page) {
            this.$router.push(page);
        },
        toQQ() {
            apis.getQqList().then(res => {
                if (res.length > 0) {
                    const url = `http://wpa.qq.com/msgrd?v=3&uin=${res[0].social}&site=qq&menu=yes`;
                    window.open(url);
                } else {
                    this.$message.error('暂无客服');
                }
            });
        },
        toTop() {
            window.scrollTo(0, 0);
        },
        onScroll() {
            window.addEventListener('scroll', () => {
                const scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                this.scrollTop = scrollTop;
            });
        },
        getRankList() {
            apis.goodsListByCategory({
                categoryId: 5,
                categoryIds: '1,2,3,4',
                goodsType: 2,
                rankState: 1,
                recommendState: 1,
            }).then(res => {
                this.gongjuListrank = res.data;
            });
        },
        getGongjuList() {},
    },
    mounted() {
        this.onScroll();

        // 工具、耗材
        this.getGongjuList();
        this.getRankList();

        this.getBrandList();
    },
};
</script>
<style lang="less">
.secondItem {
    .el-tabs__nav {
        width: 100%;
        .el-tabs__item {
            width: 20%;
            text-align: center;
            padding: 0;
        }
    }
}
</style>
<style lang="less" scoped>
p {
    margin: 0;
}

.fixed {
    width: 50px;
    position: fixed;
    bottom: 50px;
    right: 30px;
    z-index: 99;
    .item {
        width: 50px;
        height: 50px;
        margin-bottom: 5px;
        cursor: pointer;
        position: relative;
        img {
            width: 50px;
            height: 50px;
        }
    }
    .qr {
        &:hover {
            .qr-code {
                display: block;
            }
        }
        .qr-code {
            width: 150px;
            height: 150px;
            background-color: #fff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            position: absolute;
            top: -50px;
            right: 70px;
            border-radius: 6px;
            padding: 5px;
            display: none;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .qr-code::after {
            content: '';
            position: absolute;
            border-left: 10px solid #fff;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            top: 68px;
            right: -10px;
        }
    }
}

.search {
    height: 90px;
    position: relative;
}

.search .logo {
    position: absolute;
    top: 15px;
    left: 0px;
    height: 60px;
    width: 200px;
    background: url(../assets/logo.png) no-repeat;
    background-size: 100%;
}

.searchInput {
    outline: none;
    border: 0;
    width: 600px;
    height: 40px;
    position: absolute;
    top: 25px;
    right: 120px;
    padding: 0 60px 0 10px;
    border-radius: 8px;
}

.searchIcon {
    position: absolute;
    top: 25px;
    right: 120px;
    width: 40px;
    height: 40px;
    background: url(../assets/searchIcon.png) no-repeat center;
}

.structButton {
    position: absolute;
    top: 25px;
    right: 0px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    color: #ffffff;
    background-color: #3c9539;
    border-radius: 8px;
    border: 0;
}

.bannner {
    width: 100%;
}

.notice {
    margin-top: 20px;
    height: 46px;
    line-height: 46px;
    display: flex;
    background: #ffffff;
    font-size: 14px;
    color: #a2a7b7;
    .noticeIcon {
        width: 40px;
        background: url('../assets/notic.png') no-repeat;
        background-position: 100% 50%;
    }
    .mainBody {
        flex: 1;
        padding: 0 10px;
    }
    .date {
        width: 100px;
    }
}

.product {
    margin-top: 30px;
    display: flex;

    .firstItem {
        padding: 40px 10px;
        height: 566px;
        width: 200px;
        color: #ffffff;
        .name {
            font-size: 20px;
            font-weight: normal;
            margin-bottom: 20px;
        }
        .category_items {
            font-size: 12px;
            display: flex;
            flex-wrap: wrap;
            .item {
                border: 1px solid rgba(255, 255, 255, 0.5);
                border-radius: 20px;
                margin-bottom: 10px;
                margin-right: 10px;
                padding: 3px 5px;
            }
        }
    }
    .secondItem {
        width: 590px;
        background-color: #ffffff;
        padding: 0 20px;
        .nav_product_list {
            display: flex;
            flex-wrap: wrap;
            .nav_product {
                padding: 0 6.5px;
                margin-bottom: 40px;
                .name {
                    font-size: 12px;
                    height: 20px;
                    line-height: 22px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 170px;
                    overflow: hidden;
                }
                .price {
                    color: #e60012;
                    font-size: 14px;
                    font-weight: bold;
                }
            }
        }
    }
    .thirdItem {
        margin-left: 5px;
        width: 200px;
        background: #ffffff;
        padding: 0 10px;
        text-align: center;
        font-size: 12px;
        .title {
            border-bottom: 1px solid #eee;
            font-size: 14px;
            height: 42px;
            line-height: 42px;
            text-align: left;
        }
        .disc {
            height: 87px;
            margin: 15px 0;
            overflow: hidden;
            word-break: break-all;
        }
        .name {
            background-color: #eee;
            height: 24px;
            line-height: 24px;
            text-align: center;
        }
        .name2 {
            margin-top: 10px;
            border: 1px solid #eee;
            height: 30px;
            line-height: 30px;
        }
        .brandList {
            img {
                margin: 5px;
            }
        }
    }
    .fourItem {
        margin-left: 5px;
        width: 200px;
        background: #ffffff;
        padding: 0 10px;
        .title {
            border-bottom: 1px solid #eee;
            font-size: 14px;
            height: 42px;
            line-height: 42px;
        }
        .rank_product {
            display: flex;
            font-size: 12px;
            align-items: center;
            height: 100px;
            cursor: pointer;
            .left {
                margin: 0 10px;
                width: 80px;
                .name {
                    color: #333;
                }
                .price {
                    color: #e60012;
                    font-size: 14px;
                    font-weight: bold;
                }
            }
        }
    }
}

.brand {
    margin-top: 40px;
    // height: 146px;
    .items {
        width: 1264px;
        display: flex;
        flex-wrap: wrap;
        .item {
            width: 165px;
            height: 76px;
            margin: 0 8px 8px 0;
            border-radius: 10px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                border: none;
            }
        }
    }
}
</style>
